import config from 'src/config/index';

const authConfig = {
  domain: config.auth0.domain,
  clientID: config.auth0.clientID,
  redirectURI: config.auth0.redirectURI,
  audience: config.auth0.audience
};

export default authConfig;
